import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    ADDRESSBYGOOGLE_COLUMN_URI,
    AUTOCOMPLETEFROMENUMERATION_COLUMN_URI,
    AUTOCOMPLETEFROMURI_COLUMN_URI,
    AUTOCOMPLETEWITHGIVENOPTIONS_COLUMN_URI,
    AUTOCOMPLETE_FROM_MASTER_DATA,
    CATEGORYSELECT_URI,
    CHECKBOX_COLUMN_URI,
    CHIPLIST_COLUMN_URI,
    CODEBARSCANNERWITHSELECT_URI,
    CODEBAR_SCANNER_URI,
    COLOR_COLUMN_URI,
    COMPLEXTOTAL_COLUMN_URI,
    COMPLEXUNIQUEINDEX_COLUMN_URI,
    COMPLEX_MASK_URI,
    ConfigurationAlertType,
    DATEPICKER_COLUMN_URI,
    DATERANGEPICKER_COLUMN_URI,
    DATETIMEPICKER_COLUMN_URI,
    DType,
    DTYPEAUTOCOMPLETE_URI,
    DTYPEBOOLEAN_URI,
    DTYPECHIPLIST_URI,
    DTypeCol,
    DTypeComponent,
    DTYPECUSTOM_URI,
    DTYPEDATETIME_URI,
    DTYPEDECORATION_URI,
    DTYPEEMBEDDED_URI,
    DTypeFamilies,
    DTypeFamily,
    DTYPEFILE_URI,
    DTYPEFREETEXT_URI,
    DTYPENUMBER_URI,
    DTYPESELECT_URI,
    DTYPETABLE_URI,
    DTYPETEXT_URI,
    DTYPETRIGGER_URI,
    EMBEDDED_COLLECTION_COLUMN_URI,
    EMBEDDED_ITEM_COLUMN_URI,
    FIELDCHIPLIST_COLUMN_URI,
    FILE_COLUMN_URI,
    FORMATTEDTEXT_COLUMN_URI,
    ICON_COLUMN_URI,
    IMAGE_COLUMN_URI,
    INTEGER_COLUMN_URI, LANGUAGETEXTAREA_COLUMN_URI, LANGUAGETEXT_COLUMN_URI, MULTIIMAGE_COLUMN_URI,
    NextLocator,
    RADIO_COLUMN_URI, RATINGLINKEDTOTABLE_URI, RATING_COLUMN_URI,
    REAL_COLUMN_URI,
    SECTION_COLUMN_URI,
    SELECTFACADE_COLUMN_URI,
    SELECTFROMCONCEPTSERVICE_COLUMN_URI,
    SELECTFROMENUMERATION_COLUMN_URI,
    SELECTFROMMASTERDATA_COLUMN_URI, SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI, SelectFromUri, SELECTFROMURI_COLUMN_URI,
    SELECTMASTER_COLUMN_URI,
    SELECTNEXTTASKTYPE_COLUMN_URI,
    SELECTSERVICEUSERASSIGNMENT_COLUMN_URI,
    SELECTSERVICE_COLUMN_URI,
    SELECTWITHGIVENOPTIONS_COLUMN_URI, SIGNATURE_COLUMN_URI, SMILEYS_COLUMN_URI,
    SUBSECTION_COLUMN_URI, SUMMARY_MASK_URI, Table, TABLEWITHFIXEDROWS_URI, TABLEWITHRATINGLINKED_URI, TABLEWITHVARIABLEROWS_URI, TABLE_COLUMN_URI, TEXTAREA_COLUMN_URI,
    TEXTMASK_COLUMN_URI, TEXT_COLUMN_URI, TIMEPICKER_COLUMN_URI,
    TIMERANGESCONVERTER_COLUMN_URI,
    TRIGGER_COLUMN_URI,
    TRISTATE_COLUMN_URI,
    TWOCOLUMNSTABLE_URI,
    USERPROFILECHIPLIST_COLUMN_URI,
    USERSELECT_COLUMN_URI,
    WYSIWYG_COLUMN_URI
} from '@grupo-constant/next-dtype/types';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { cloneDeep } from 'lodash-es';
import { DndDropEvent, DndModule } from 'ngx-drag-drop';
import { BehaviorSubject, firstValueFrom, skip, Subject, Subscription, takeUntil } from 'rxjs';

import { DtypeFieldEditDialogComponent } from '../dtype-field-edit/dtype-field-edit.dialog';
import { DTypeService } from '../dtype.service';
import * as lodash from 'lodash-es';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { LocalizePipe } from '../../pipes/standalone/localize.pipe';
import { ClipboardService } from '../../clipboard/clipboard.service';
import { DialogsService } from '../../../dialogs/dialogs.service';
import { Events } from '../../events/events.service';
import { FuseConfirmationService } from '../../../../@fuse/services/confirmation/confirmation.service';
import { Clipboard } from '../../clipboard/clipboard.model';
import { MasterData } from '../../master/master.types';

@Component({
    selector: 'dtype-fieldlist',
    templateUrl: './dtype-fieldlist.component.html',
    styleUrls: ['./dtype-fieldlist.component.scss'],
    imports: [CommonModule, MatProgressBarModule, MatCheckboxModule, FormsModule, TranslocoModule, LocalizePipe,
        MatIconModule, MatTooltipModule, DndModule, OverlayModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class DtypeFieldlistComponent implements OnInit, OnDestroy, OnChanges {

    @Input() dtype: DType;
    @Input() locator: NextLocator;
    @Input() readonly = false;
    @Output() changed = new EventEmitter<{ columns: DTypeCol[]; dtype: DType }>();

    columns$: BehaviorSubject<DTypeCol[]> = new BehaviorSubject([]);
    viewColumns$: BehaviorSubject<DTypeCol[]> = new BehaviorSubject([]);

    selection = new SelectionModel<number>(true, []);
    tableViewExpanded: number[] = [];
    selectionByFieldName = new Map<string, SelectionModel<number>>();

    typeFamilies: DTypeFamilies;
    familyList: DTypeFamily[];
    selectedFamily: DTypeFamily;

    isLoading = true;

    // FILTERS
    showHiddenColumns = false;

    clipboard: Clipboard[] = [];
    pasteEventSubscription: Subscription;

    readonly tableComponentUri = 'component://com.cloudcodice.feature.dtype.column.component.TableComponent';

    private unsubcribeAll = new Subject<void>();

    constructor(
        private clipboardService: ClipboardService,
        private dialogsService: DialogsService,
        private dtypeService: DTypeService,
        private events: Events,
        private _fuseConfirmationService: FuseConfirmationService,
        private _matDialog: MatDialog,
        private translocoService: TranslocoService
    ) { }

    async ngOnInit() {
        this.typeFamilies = await firstValueFrom(this.dtypeService.retrieveDTypeBuilderCollection());
        this.createOrderedFamilyList();

        this.updateColumns();
        this.viewColumns$.next(this.dtype.column
            .filter(c => this.showHiddenColumns || !this.columnIsHidden(c))
            .map((c) => {
                if (c.type === this.tableComponentUri) {
                    this.selectionByFieldName.set(c.name, new SelectionModel<number>(true, []));
                }
                return c;
            }));
        this.columns$.pipe(
            skip(1),
            takeUntil(this.unsubcribeAll)
        ).subscribe((columns) => {
            this.viewColumns$.next(columns.filter(c => this.showHiddenColumns || !this.columnIsHidden(c))); // Columns starting with "_" are considered hidden
            this.changed.emit({ columns, dtype: this.dtype });
        });

        this.clipboardService.clipboard$
            .pipe(takeUntil(this.unsubcribeAll))
            .subscribe(clipboard => this.clipboard = clipboard.filter(clip => (this.dtype.uri.startsWith('form') && clip.type === 'formField') || (this.dtype.uri.startsWith('master') && clip.type === 'masterField')
                || (this.dtype.uri.startsWith('taskType') && clip.type === 'tasktypeField')));

        this.pasteEventSubscription = this.events.subscribe('paste-' + (this.dtype.uri.startsWith('form') ? 'formField'
            : this.dtype.uri.startsWith('master') ? 'masterField' : 'tasktypeField'), async (data: string) => {
                const question: DTypeCol = JSON.parse(data);
                await this.addColumnFromClipboard(question);
            });
        this.isLoading = false;
    }

    ngOnDestroy() {
        this.unsubcribeAll.next();
        this.unsubcribeAll.complete();
        this.pasteEventSubscription.unsubscribe();
    }

    ngOnChanges() {
        this.updateColumns();
    }

    /**
     * Marca o desmarca todos los checks de la tabla
     */
    masterToggle(table?: Table): void {
        const selection = table ? this.selectionByFieldName.get(table.name) : this.selection;
        if (this.isAllSelected(table)) {
            selection.clear();
        } else {
            selection.clear();
            const columns = table ? table.dtype.column : this.viewColumns$.getValue();
            columns.forEach((value, index) => {
                if (!this.columnIsHidden(value)) {
                    selection.toggle(index);
                }
            });
        }
    }

    isAllSelected(table?: Table): boolean {
        const selection = table ? this.selectionByFieldName.get(table.name) : this.selection;
        const columns = table ? table.dtype.column : this.viewColumns$.getValue();
        return selection.selected.length === columns.filter(c => !this.columnIsHidden(c)).length;
    }

    columnIsHidden(column: DTypeCol) {
        return column.name.startsWith('_');
    }

    indexFirstHiddenColumn(): number {
        return this.columns$.getValue().findIndex(c => this.columnIsHidden(c));
    }

    /**
     * Returns if a family has any component for design
     *
     * @returns
     */
    familyForDesign(family: DTypeFamily): any {
        for (const component of family.component) {
            if (component.design && ((this.dtype.uri.startsWith('form') && component.formDesign) || (this.dtype.uri.startsWith('master') && component.masterDesign)
                || (this.dtype.uri.startsWith('taskType') && component.tasktypeDesign))) {
                return true;
            }
        }
        return false;
    }

    isExpanded(index: number) {
        return this.tableViewExpanded.findIndex(i => i === index) > -1;
    }

    toggleTableView(event: MouseEvent, index: number) {
        event?.stopPropagation();
        const tableViewIndex = this.tableViewExpanded.findIndex(i => i === index);
        if (tableViewIndex > -1) {
            this.tableViewExpanded.splice(tableViewIndex, 1);
        } else {
            this.tableViewExpanded = [];
            this.tableViewExpanded.push(index);
        }
    }

    async pasteQuestions(table?: Table) {
        for (const clipboard of this.clipboard) {
            const question: DTypeCol = JSON.parse(clipboard.data);
            await this.addColumnFromClipboard(question, table);
        }
    }

    /**
     * Abre un diálogo para modificar un campo
     *
     * @param column campo que se va a modificar
     */
    openColumn(column: DTypeCol, table?: Table) {
        if (this.columnIsHidden(column)) {
            return;
        }
        if (column.type === TABLE_COLUMN_URI) {
            this.dtypeService.tableComponentColumns$.next((column as Table).dtype.column);
        }
        const oldName = structuredClone(column.name);
        const dialogRef = this._matDialog.open(DtypeFieldEditDialogComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'dtype-field-edit-dialog-panel',
            height: '80vh',
            width: '80vw',
            maxWidth: '1536px',
            data: {
                dtypeColumn: cloneDeep(column),
                dtypeUri: column.type,
                locator: this.locator,
                readonly: this.readonly,
                dtype: table ? table.dtype : this.dtype,
                parentDtype: table ? this.dtype : undefined,
                table,
                isUpdate: true
            },
        });

        dialogRef.componentInstance.updateDtype
            .pipe(takeUntil(this.unsubcribeAll))
            .subscribe((dtype) => {
                if (dtype && !table) {
                    this.dtype = dtype;
                    this.updateColumns();
                } else if (dtype && table) {
                    table.dtype = dtype;
                }
            });

        dialogRef.componentInstance.update
            .pipe(takeUntil(this.unsubcribeAll))
            .subscribe((dtypeCol) => {
                if (dtypeCol) {
                    this.updateColumn(dtypeCol, oldName, table);
                }
            });

        dialogRef.afterClosed()
            .pipe(takeUntil(this.unsubcribeAll))
            .subscribe((result) => {
                if (result) {
                    this.updateColumn(result, oldName, table);
                }
            });
    }

    async removeColumns(selected: number[], table?: Table): Promise<void> {
        if (await this.confirm()) {
            const selection = table ? this.selectionByFieldName.get(table.name) : this.selection;
            selection.clear();
            const columns = table ? table.dtype.column : this.columns$.getValue();
            const deletedColumns: DTypeCol[] = [];
            for (const index of selected.sort((a, b) => b - a)) { // Se borra desde las posiciones mayores
                deletedColumns.push(...columns.splice(index, 1));
            }
            //* Se borran los path que haya de los campos que se están borrando
            // const dtype = table ? table.dtype : this.dtype;
            // const deletedPaths: ConditionPath[] = [];
            //* Primero se buscan los paths a partir de los campos borrados
            // for (const col of deletedColumns) {
            //     deletedPaths.push(...dtype.path.filter(p => p.field === col.name));
            // }
            //* Se borran los paths
            // for (const path of deletedPaths) {
            //     const pathIndex = dtype.path.findIndex(p => p.path === path.path);
            //     if (pathIndex > 0) {
            //         dtype.path.splice(pathIndex, 1);
            //     }
            // }
            //* Por ultimo, se eliminan de los command de cada campo los paths
            // for (const col of columns) {
            //     for (const command of col.command ?? []) {
            //         command.path = command.path.filter(path => !deletedPaths.map(p => p.path).includes(path));
            //     }
            // }
            for (const col of deletedColumns) {
                this.updatePathsAndFiltersNames(this.dtype, col.name, undefined, table);
            }
            if (!table) {
                this.updateColumns();
            }
        }
    }

    copyItem(event: PointerEvent, column: DTypeCol) {
        event.stopPropagation();
        if (this.dtype.uri.startsWith('form') || this.dtype.uri.startsWith('master') || this.dtype.uri.startsWith('taskType')) {
            this.clipboardService.addToClipboard({
                data: JSON.stringify(column),
                name: column.name,
                type: this.dtype.uri.startsWith('form') ? 'formField' : this.dtype.uri.startsWith('master') ? 'masterField' : this.dtype.uri.startsWith('taskType') ? 'tasktypeField' : '',
            });
        }
    }

    drop(event: DndDropEvent, table?: Table) {
        if (event.dropEffect === 'copy') {
            this.addComponent(event.data, event.index, table);
        } else if (event.dropEffect === 'move') {
            // this.onDragMove(event.data, table);
            this.moveColumn(event.data, event.index, table);
        }
    }

    getType(column: DTypeCol) {
        switch (column.type) {
            case AUTOCOMPLETEFROMENUMERATION_COLUMN_URI:
            case AUTOCOMPLETEWITHGIVENOPTIONS_COLUMN_URI:
            case AUTOCOMPLETEFROMURI_COLUMN_URI:
            case AUTOCOMPLETE_FROM_MASTER_DATA:
                return this.typeFamilies[DTYPEAUTOCOMPLETE_URI]?.caption;
            case CHECKBOX_COLUMN_URI:
            case RADIO_COLUMN_URI:
            case TRISTATE_COLUMN_URI:
            case SMILEYS_COLUMN_URI:
                return this.typeFamilies[DTYPEBOOLEAN_URI]?.caption;
            case EMBEDDED_COLLECTION_COLUMN_URI:
            case EMBEDDED_ITEM_COLUMN_URI:
            case TABLEWITHFIXEDROWS_URI:
            case TABLEWITHVARIABLEROWS_URI:
                return this.typeFamilies[DTYPEEMBEDDED_URI]?.caption;
            case INTEGER_COLUMN_URI:
            case REAL_COLUMN_URI:
            case RATING_COLUMN_URI:
                return this.typeFamilies[DTYPENUMBER_URI]?.caption;
            case SELECTFROMENUMERATION_COLUMN_URI:
            case SELECTWITHGIVENOPTIONS_COLUMN_URI:
            case SELECTFROMURI_COLUMN_URI:
            case SELECTMASTER_COLUMN_URI:
            case SELECTFACADE_COLUMN_URI:
            case SELECTFROMCONCEPTSERVICE_COLUMN_URI:
            case SELECTFROMMASTERDATA_COLUMN_URI:
            case SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI:
            case SELECTNEXTTASKTYPE_COLUMN_URI:
            case CODEBARSCANNERWITHSELECT_URI:
            case SELECTSERVICE_COLUMN_URI:
            case SELECTSERVICEUSERASSIGNMENT_COLUMN_URI:
            case USERSELECT_COLUMN_URI:
                return this.typeFamilies[DTYPESELECT_URI]?.caption;
            case TEXT_COLUMN_URI:
            case TEXTAREA_COLUMN_URI:
            case LANGUAGETEXT_COLUMN_URI:
            case LANGUAGETEXTAREA_COLUMN_URI:
            case TEXTMASK_COLUMN_URI:
            case COMPLEXUNIQUEINDEX_COLUMN_URI:
            case COMPLEXTOTAL_COLUMN_URI:
            case CODEBAR_SCANNER_URI:
            case COMPLEX_MASK_URI:
            case SUMMARY_MASK_URI:
                return this.typeFamilies[DTYPETEXT_URI]?.caption;
            case TRIGGER_COLUMN_URI:
                return this.typeFamilies[DTYPETRIGGER_URI]?.caption;
            case DATEPICKER_COLUMN_URI:
            case DATERANGEPICKER_COLUMN_URI:
            case DATETIMEPICKER_COLUMN_URI:
            case TIMEPICKER_COLUMN_URI:
            case TIMERANGESCONVERTER_COLUMN_URI:
                return this.typeFamilies[DTYPEDATETIME_URI]?.caption;
            case CHIPLIST_COLUMN_URI:
            case USERPROFILECHIPLIST_COLUMN_URI:
            case FIELDCHIPLIST_COLUMN_URI:
            case CATEGORYSELECT_URI:
                return this.typeFamilies[DTYPECHIPLIST_URI]?.caption;
            case FILE_COLUMN_URI:
            case MULTIIMAGE_COLUMN_URI:
            case IMAGE_COLUMN_URI:
            case SIGNATURE_COLUMN_URI:
                return this.typeFamilies[DTYPEFILE_URI]?.caption;
            case FORMATTEDTEXT_COLUMN_URI:
            case SECTION_COLUMN_URI:
            case SUBSECTION_COLUMN_URI:
            case WYSIWYG_COLUMN_URI:
                return this.typeFamilies[DTYPEFREETEXT_URI]?.caption;
            case ADDRESSBYGOOGLE_COLUMN_URI:
            case TWOCOLUMNSTABLE_URI:
            case RATINGLINKEDTOTABLE_URI:
            case TABLEWITHRATINGLINKED_URI:
                return this.typeFamilies[DTYPECUSTOM_URI]?.caption;
            case ICON_COLUMN_URI:
            case COLOR_COLUMN_URI:
                return this.typeFamilies[DTYPEDECORATION_URI]?.caption;
            case TABLE_COLUMN_URI:
                return this.typeFamilies[DTYPETABLE_URI]?.caption;
        }
    }

    getView(column: DTypeCol) {
        switch (column.type) {
            case AUTOCOMPLETEFROMENUMERATION_COLUMN_URI:
            case AUTOCOMPLETEWITHGIVENOPTIONS_COLUMN_URI:
            case AUTOCOMPLETEFROMURI_COLUMN_URI:
            case AUTOCOMPLETE_FROM_MASTER_DATA:
                return this.getViewCaption(column, DTYPEAUTOCOMPLETE_URI);
            case CHECKBOX_COLUMN_URI:
            case RADIO_COLUMN_URI:
            case TRISTATE_COLUMN_URI:
            case SMILEYS_COLUMN_URI:
                return this.getViewCaption(column, DTYPEBOOLEAN_URI);
            case EMBEDDED_COLLECTION_COLUMN_URI:
            case EMBEDDED_ITEM_COLUMN_URI:
            case TABLEWITHFIXEDROWS_URI:
            case TABLEWITHVARIABLEROWS_URI:
                return this.getViewCaption(column, DTYPEEMBEDDED_URI);
            case INTEGER_COLUMN_URI:
            case REAL_COLUMN_URI:
            case RATING_COLUMN_URI:
                return this.getViewCaption(column, DTYPENUMBER_URI);
            case SELECTFROMENUMERATION_COLUMN_URI:
            case SELECTWITHGIVENOPTIONS_COLUMN_URI:
            case SELECTFROMURI_COLUMN_URI:
            case SELECTMASTER_COLUMN_URI:
            case SELECTFACADE_COLUMN_URI:
            case SELECTFROMCONCEPTSERVICE_COLUMN_URI:
            case SELECTFROMMASTERDATA_COLUMN_URI:
            case SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI:
            case CODEBARSCANNERWITHSELECT_URI:
            case SELECTSERVICE_COLUMN_URI:
            case SELECTSERVICEUSERASSIGNMENT_COLUMN_URI:
            case USERSELECT_COLUMN_URI:
                return this.getViewCaption(column, DTYPESELECT_URI);
            case TEXT_COLUMN_URI:
            case TEXTAREA_COLUMN_URI:
            case LANGUAGETEXT_COLUMN_URI:
            case LANGUAGETEXTAREA_COLUMN_URI:
            case TEXTMASK_COLUMN_URI:
            case COMPLEXUNIQUEINDEX_COLUMN_URI:
            case COMPLEXTOTAL_COLUMN_URI:
            case CODEBAR_SCANNER_URI:
            case COMPLEX_MASK_URI:
            case SUMMARY_MASK_URI:
                return this.getViewCaption(column, DTYPETEXT_URI);
            case TRIGGER_COLUMN_URI:
                return this.getViewCaption(column, DTYPETRIGGER_URI);
            case DATEPICKER_COLUMN_URI:
            case DATERANGEPICKER_COLUMN_URI:
            case DATETIMEPICKER_COLUMN_URI:
            case TIMEPICKER_COLUMN_URI:
            case TIMERANGESCONVERTER_COLUMN_URI:
                return this.getViewCaption(column, DTYPEDATETIME_URI);
            case CHIPLIST_COLUMN_URI:
            case USERPROFILECHIPLIST_COLUMN_URI:
            case FIELDCHIPLIST_COLUMN_URI:
            case CATEGORYSELECT_URI:
                return this.getViewCaption(column, DTYPECHIPLIST_URI);
            case FILE_COLUMN_URI:
            case MULTIIMAGE_COLUMN_URI:
            case IMAGE_COLUMN_URI:
            case SIGNATURE_COLUMN_URI:
                return this.getViewCaption(column, DTYPEFILE_URI);
            case FORMATTEDTEXT_COLUMN_URI:
            case SECTION_COLUMN_URI:
            case SUBSECTION_COLUMN_URI:
            case WYSIWYG_COLUMN_URI:
                return this.getViewCaption(column, DTYPEFREETEXT_URI);
            case ADDRESSBYGOOGLE_COLUMN_URI:
            case TWOCOLUMNSTABLE_URI:
            case RATINGLINKEDTOTABLE_URI:
            case TABLEWITHRATINGLINKED_URI:
                return this.getViewCaption(column, DTYPECUSTOM_URI);
            case ICON_COLUMN_URI:
            case COLOR_COLUMN_URI:
                return this.getViewCaption(column, DTYPEDECORATION_URI);
            case TABLE_COLUMN_URI:
                return this.getViewCaption(column, DTYPETABLE_URI);
        }
    }

    toggleHiddenColumns(): void {
        const columns = this.columns$.getValue();
        this.viewColumns$.next(columns.filter(c => this.showHiddenColumns || !this.columnIsHidden(c)));
    }

    chooseAlertIcon(type: string) {
        switch (type) {
            case 'ERROR':
                return 'mat_outline:error_outline';
            case 'WARNING':
                return 'mat_outline:warning_amber';
        }

    }

    chooseColorIcon(type: string) {
        switch (type) {
            case 'ERROR':
                return 'error-icon';
            case 'WARNING':
                return 'warning-icon';
        }
    }

    toggleError($event: PointerEvent, column: DTypeCol, table?: Table) {
        $event.stopPropagation();
        column.showError = !column.showError;
        if (column.showError) {
            for (const col of this.dtype.column ?? []) {
                if (table || col.name !== column.name) {
                    col.showError = false;
                }
                if (col.type === TABLE_COLUMN_URI) {
                    for (const tableCol of (col as Table).dtype.column) {
                        if (!table || table.name !== col.name || tableCol.name !== column.name) {
                            tableCol.showError = false;
                        }
                    }
                }
            }
        }
    }

    /**
     * Create an ordered list of families based on the expected use
     *
     * If a new family is created on server, it is necessary to update this method
     */
    private createOrderedFamilyList() {
        this.familyList = [];
        // Text
        if (this.typeFamilies[DTYPETEXT_URI]) {
            this.familyList.push(this.typeFamilies[DTYPETEXT_URI]);
        }
        // Boolean
        if (this.typeFamilies[DTYPEBOOLEAN_URI]) {
            this.familyList.push(this.typeFamilies[DTYPEBOOLEAN_URI]);
        }
        // Number
        if (this.typeFamilies[DTYPENUMBER_URI]) {
            this.familyList.push(this.typeFamilies[DTYPENUMBER_URI]);
        }
        // Select
        if (this.typeFamilies[DTYPESELECT_URI]) {
            this.familyList.push(this.typeFamilies[DTYPESELECT_URI]);
        }
        // Table
        if (this.typeFamilies[DTYPETABLE_URI]) {
            this.familyList.push(this.typeFamilies[DTYPETABLE_URI]);
        }
        // Datetime
        if (this.typeFamilies[DTYPEDATETIME_URI]) {
            this.familyList.push(this.typeFamilies[DTYPEDATETIME_URI]);
        }
        // File
        if (this.typeFamilies[DTYPEFILE_URI]) {
            this.familyList.push(this.typeFamilies[DTYPEFILE_URI]);
        }
        // Autocomplete
        if (this.typeFamilies[DTYPEAUTOCOMPLETE_URI]) {
            this.familyList.push(this.typeFamilies[DTYPEAUTOCOMPLETE_URI]);
        }
        // Custom
        if (this.typeFamilies[DTYPECUSTOM_URI]) {
            this.familyList.push(this.typeFamilies[DTYPECUSTOM_URI]);
        }
        // Decoration
        if (this.typeFamilies[DTYPEDECORATION_URI]) {
            this.familyList.push(this.typeFamilies[DTYPEDECORATION_URI]);
        }
        // Chiplist
        if (this.typeFamilies[DTYPECHIPLIST_URI]) {
            this.familyList.push(this.typeFamilies[DTYPECHIPLIST_URI]);
        }
        // Freetext
        if (this.typeFamilies[DTYPEFREETEXT_URI]) {
            this.familyList.push(this.typeFamilies[DTYPEFREETEXT_URI]);
        }
        // Trigger
        if (this.typeFamilies[DTYPETRIGGER_URI]) {
            this.familyList.push(this.typeFamilies[DTYPETRIGGER_URI]);
        }
        // Embedded
        if (this.typeFamilies[DTYPEEMBEDDED_URI]) {
            this.familyList.push(this.typeFamilies[DTYPEEMBEDDED_URI]);
        }
    }

    private getViewCaption(column: DTypeCol, dtypeUri: string) {
        const componentList = this.typeFamilies[dtypeUri]?.component;
        if (componentList) {
            return componentList.find(c => c.uri === column.type)?.caption;
        }
    }

    /**
     * Open a dialog for adding a new column to the dtype and add the column to the columns array
     *
     * @param component
     */
    private addComponent(component: DTypeComponent, index: number, table?: Table) {
        if (component.uri === TABLE_COLUMN_URI && table) {
            this.dialogsService.openErrorDialog({
                title: this.translocoService.translate('warning'),
                message: this.translocoService.translate('cantCreateTableInsideTable')
            });
            return;
        } else if (component.uri === TABLE_COLUMN_URI) {
            this.dtypeService.tableComponentColumns$.next([]);
        }
        const dialogRef = this._matDialog.open(DtypeFieldEditDialogComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'dtype-field-edit-dialog-panel',
            height: '80vh',
            width: '80vw',
            maxWidth: '1536px',
            data: {
                dtypeUri: component.uri,
                locator: this.locator,
                dtype: table ? table.dtype : this.dtype,
                parentDtype: table ? this.dtype : undefined,
                table,
                isUpdate: false,
            }
        });

        dialogRef.afterClosed()
            .pipe(takeUntil(this.unsubcribeAll))
            .subscribe((result) => {
                if (result) {
                    this.addColumn(result, index, table);
                }
            });
    }

    /**
     * Open a dialog for adding a new column from the clipboard with the posibility of waiting to end to the dtype and add the column to the columns array
     *
     * @param component
     */
     private addColumnFromClipboard(column: DTypeCol, table?: Table) {
        return new Promise<void>(resolve => {
            if (column.type === TABLE_COLUMN_URI && table) {
                this.dialogsService.openErrorDialog({
                    title: this.translocoService.translate('warning'),
                    message: this.translocoService.translate('cantCreateTableInsideTable')
                });
                resolve();
                return;
            } else if (column.type === TABLE_COLUMN_URI) {
                this.dtypeService.tableComponentColumns$.next([]);
            }
            const dtypeColumn = lodash.cloneDeep(column);
            const dialogRef = this._matDialog.open(DtypeFieldEditDialogComponent, {
                autoFocus: false,
                disableClose: true,
                panelClass: 'dtype-field-edit-dialog-panel',
                height: '80vh',
                width: '80vw',
                maxWidth: '1536px',
                data: {
                    dtypeColumn,
                    dtypeUri: column.type,
                    locator: this.locator,
                    dtype: table ? table.dtype : this.dtype,
                    parentDtype: table ? this.dtype : undefined,
                    table,
                    isUpdate: false
                }
            });

            dialogRef.afterClosed()
                .pipe(takeUntil(this.unsubcribeAll))
                .subscribe((result) => {
                    if (result) {
                        this.addColumn(result, 0, table);
                    }
                    resolve();
                });
        });
    }

    private addColumn(column: DTypeCol, index: number, table?: Table) {
        const columns = table ? table.dtype?.column ?? [] : this.columns$.getValue();
        if (column.type === TABLE_COLUMN_URI) {
            const tableColumn = column as Table;
            if (tableColumn.dtype) { // Es la copia de otra table
                tableColumn.dtype.caption = tableColumn.caption;
            } else {
                tableColumn.dtype = {
                    alert: [],
                    caption: (column as Table).caption,
                    column: [],
                    errorStatus: ConfigurationAlertType.INFO,
                    path: [],
                    uri: '',
                };
            }
        }
        if (!index) {
            columns.push(column);
        } else {
            columns.splice(index, 0, column);
        }
        if (!table) {
            this.updateColumns();
        }
        if (column.type === TABLE_COLUMN_URI) {
            this.toggleTableView(undefined, !index ? columns.findIndex(c => c.name === column.name) : index);
        }
        if (column.type === 'component://com.cloudcodice.feature.dtype.column.component.TableComponent' && !table) {
            this.selectionByFieldName.set(column.name, new SelectionModel<number>(true, []));
        }
    }

    private updateColumn(column: DTypeCol, oldName: string, table?: Table) {
        const columns = table ? table.dtype?.column ?? [] : this.columns$.getValue();
        const index = columns.findIndex(c => c.name === oldName);
        if (index > -1) {
            if (oldName !== column.name) {
                this.updatePathsAndFiltersNames(this.dtype, oldName, column.name, table);
                if (column.type === TABLE_COLUMN_URI) {
                    (column as Table).name = column.name;
                    const selection = this.selectionByFieldName.get(oldName);
                    this.selectionByFieldName.set(column.name, selection);
                    this.selectionByFieldName.delete(oldName);
                }
            }
            columns.splice(index, 1, column);
            if (!table) {
                this.updateColumns();
            }
        }
    }

    private updatePathsAndFiltersNames(dtype: DType, oldName: string, newName: string, table?: Table) {
        const deletedPaths: string[] = [];
        for (const path of dtype.path) {
            if (path.field === oldName) {
                if (newName) {
                    path.field = newName;
                } else {
                    deletedPaths.push(path.path);
                }
            }
        }
        if (deletedPaths.length > 0) {
            //* Se borran los paths
            for (const path of deletedPaths.reverse()) {
                const pathIndex = dtype.path.findIndex(p => p.path === path);
                if (pathIndex > -1) {
                    dtype.path.splice(pathIndex, 1);
                }
            }
            const columns = table ? table.dtype.column : this.columns$.getValue();
            //* Se eliminan de los command de cada campo los paths
            for (const col of columns) {
                for (const command of col.command ?? []) {
                    command.path = command.path.filter(path => !deletedPaths.includes(path));
                }
            }
        }

        for (const field of dtype.column) {
            if ((field as SelectFromUri).filter?.length) {
                const filtersToDelete: number[] = [];
                (field as SelectFromUri).filter.forEach((filter, index) => {
                    if (filter.outerField === oldName) {
                        if (newName) {
                            filter.outerField = newName;
                        } else {
                            filtersToDelete.push(index);
                        }
                    }
                });
                if (filtersToDelete.length > 0) {
                    for (const filterIndex of filtersToDelete) {
                        (field as SelectFromUri).filter.splice(filterIndex, 1);
                    }
                }
            }
            if ((field as Table).dtype) {
                this.updatePathsAndFiltersNames((field as Table).dtype, oldName, newName);
            }
        }

        if (table) {
            if (table.uniqueIndex?.length) {
                const index = table.uniqueIndex.findIndex(i => i === oldName);
                if (index > -1) {
                    if (newName) {
                        table.uniqueIndex[index] = newName;
                    } else {
                        table.uniqueIndex.splice(index, 1);
                    }
                }
            }
            if (table.totalFields?.length) {
                const index = table.totalFields.findIndex(i => i === oldName);
                if (index > -1) {
                    if (newName) {
                        table.totalFields[index] = newName;
                    } else {
                        table.totalFields.splice(index);
                    }
                }
            }
            if (table.nameIndex?.includes(`{{${oldName}}}`)) {
                if (newName) {
                    table.nameIndex = table.nameIndex.replaceAll(`{{${oldName}}}`, `{{${newName}}}`);
                } else {
                    table.nameIndex = table.nameIndex.replaceAll(`{{${oldName}}}`, '');
                }
            }
            if (table.textForSummary?.includes(`{{${oldName}}}`)) {
                if (newName) {
                    table.textForSummary = table.textForSummary.replaceAll(`{{${oldName}}}`, `{{${newName}}}`);
                } else {
                    table.textForSummary = table.textForSummary.replaceAll(`{{${oldName}}}`, '');
                }
            }
        }

        if (dtype.uri.startsWith('form://') || dtype.uri.startsWith('master://')) {
            this.events.publish('updateFieldName', { oldName, newName });
        }

        if (dtype.uri.startsWith('master://')) {
            const master = dtype as MasterData;
            if (master.availableColumnsForList?.length) {
                const index = master.availableColumnsForList.findIndex(i => i === oldName);
                if (index > -1) {
                    if (newName) {
                        master.availableColumnsForList[index] = newName;
                    } else {
                        master.availableColumnsForList.splice(index, 1);
                    }
                }
            }
            if (master.columnsForList?.length) {
                const index = master.columnsForList.findIndex(i => i === oldName);
                if (index > -1) {
                    if (newName) {
                        master.columnsForList[index] = newName;
                    } else {
                        master.columnsForList.splice(index, 1);
                    }
                }
            }
        }
    }

    /**
     * Mueve un campo a un nuevo lugar en la lista
     *
     * @param column columna que se va a mover
     * @param newIndex indice destino de la columna
     * @param table campo de tipo tabla en el que puede estar la columna
     */
    private moveColumn(column: DTypeCol, newIndex: number, table?: Table): void {
        const columns = table ? table.dtype?.column ?? [] : this.columns$.getValue();
        const viewableColumns = columns.filter(c => !this.columnIsHidden(c));
        if (newIndex <= viewableColumns.length) {
            const currentIndex = columns.findIndex(c => c.name === column.name);
            if (currentIndex > -1) {
                // columns.splice(newIndex, 0, columns.splice(currentIndex, 1)[0]);
                if (currentIndex < newIndex) {
                    columns.splice(newIndex, 0, column); // Add moved element to the new index
                    columns.splice(currentIndex, 1); // Remove moved element from the previous index
                } else if (currentIndex > newIndex) {
                    columns.splice(currentIndex, 1); // Remove moved element from the previous index
                    columns.splice(newIndex, 0, column); // Add moved element to the new index
                }
            }
            if (!table) {
                this.updateColumns();
                this.tableViewExpanded = [];
            }
        }
    }

    private updateColumns() {
        if (!this.dtype.column) {
            this.dtype.column = [];
        }
        this.columns$.next(this.dtype.column.sort((a, b) => {
            if ((this.columnIsHidden(a) && this.columnIsHidden(b)) || (!this.columnIsHidden(a) && !this.columnIsHidden(b))) {
                return 0;
            } else {
                return this.columnIsHidden(a) ? 1 : -1;
            }
        }));
    }

    private confirm() {
        const dialogRef = this._fuseConfirmationService.open({
            title: this.translocoService.translate('warning'),
            message: this.translocoService.translate('removeColumnsConfirm'),
            actions: {
                confirm: {
                    label: this.translocoService.translate('accept')
                },
                cancel: {
                    label: this.translocoService.translate('cancel')
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed()
                .pipe(takeUntil(this.unsubcribeAll))
                .subscribe((result) => {
                    if (result === 'confirmed') {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
        });
    }
}
